import { combineEpics } from 'redux-observable'
import { authenticationEpics } from './Authentication/index.js'
import { invitationEpics } from './Invitation/index.js'
import { orderEpics } from './Order/index.js'
import { messageEpics } from './Application/index.js'
import { connectToServerEpic } from './Websocket/ConnectToServerEpic.js'
import { handleMessagesEpic } from './Websocket/HandleMessagesEpic.js'
import { updateSubscriptionEpic } from './Websocket/UpdateSubscription.js'
import { resyncOnReconnectEpic } from './Websocket/ResyncOnReconnectEpic.js'
import { reconnectWebsocketEpic } from './Websocket/ReconnectWebsocketEpic.js'
import { connectivityEpics } from './Connectivity/index.js'
import { projectEpics } from './Project/index.js'
import { organizationEpics } from './Organization/index.js'
import { otuEpics } from './Otu/index.js'
import { visualizationEpics } from './Visualization/index.js'
import { billingEpics } from './Billing/index.js'
import { chatEpics } from './Chat/index.js'
import { adminSpinEpics } from './AdminSpin/index.js'
import { orderWizardEpics } from './OrderWizard/index.ts'
import { spinEpics } from './Spin/index.ts'

export const Epics = combineEpics(
  authenticationEpics,
  invitationEpics,
  orderEpics,
  messageEpics,
  connectToServerEpic,
  handleMessagesEpic,
  updateSubscriptionEpic,
  resyncOnReconnectEpic,
  reconnectWebsocketEpic,
  connectivityEpics,
  projectEpics,
  organizationEpics,
  otuEpics,
  visualizationEpics,
  billingEpics,
  chatEpics,
  adminSpinEpics,
  orderWizardEpics,
  spinEpics
)
